// extracted by mini-css-extract-plugin
module.exports = {"userName":"_2WzoJFVtlx9IGLcfE-nf8v"};